import { render, staticRenderFns } from "./branchTransferTable.vue?vue&type=template&id=5d511920"
import script from "./branchTransferTable.vue?vue&type=script&lang=js"
export * from "./branchTransferTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports